"use client";

import { c as _c } from "react/compiler-runtime";
import { useTheme } from "next-themes";
import ProstackLogoIcon from "../icons/prostack-logo-icon";
import { Button } from "../ui/button";
import Link from "@/components/atoms/link";
import LoadingThreeDots from "../atoms/loading-three-dots";
import { LINK_SUPPORT_DOCUMENTATION_SUPPORT } from "@/lib/links";
import { Mail } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Turnstile } from "@marsidev/react-turnstile";
export default function Login(t0) {
  const $ = _c(53);
  const {
    errorText,
    successText,
    loading,
    emailLoading,
    handleGoogleLogin,
    handleGitHubLogin,
    handleMagicLink,
    magicLinkEmail,
    onMagicLinkEmailChange,
    turnstileSiteKey,
    turnstileRef,
    turnstileToken,
    onTurnstileSuccess,
    onTurnstileExpire
  } = t0;
  const {
    resolvedTheme
  } = useTheme();
  const turnstileTheme = resolvedTheme === "dark" ? "dark" : resolvedTheme === "light" ? "light" : "auto";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center justify-center"><ProstackLogoIcon /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-center"><h1 className="text-3xl font-bold">Welcome back!</h1><p className="text-muted-foreground">Sign in to manage your servers.</p></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== errorText) {
    t3 = errorText && <div className="rounded-md bg-red-100 p-4 text-red-900"><p>{errorText}</p></div>;
    $[2] = errorText;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== successText) {
    t4 = successText && <div className="rounded-md bg-green-100 p-4 text-green-900"><p>{successText}</p></div>;
    $[4] = successText;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <GoogleIcon />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== handleGoogleLogin || $[8] !== loading) {
    t6 = <Button disabled={loading} variant="outline" onClick={handleGoogleLogin} className="w-full justify-center gap-2">{t5}Google</Button>;
    $[7] = handleGoogleLogin;
    $[8] = loading;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <GitHubIcon />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== handleGitHubLogin || $[12] !== loading) {
    t8 = <Button disabled={loading} variant="outline" onClick={handleGitHubLogin} className="w-full justify-center gap-2">{t7}GitHub</Button>;
    $[11] = handleGitHubLogin;
    $[12] = loading;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t8) {
    t9 = <div className="grid grid-cols-2 gap-3">{t6}{t8}</div>;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="absolute inset-0 flex items-center"><span className="w-full border-t" /></div>;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="relative">{t10}<div className="relative flex justify-center text-xs uppercase"><span className="bg-background px-2 text-muted-foreground">or</span></div></div>;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== handleMagicLink || $[20] !== magicLinkEmail) {
    t12 = e => {
      e.preventDefault();
      handleMagicLink(magicLinkEmail);
    };
    $[19] = handleMagicLink;
    $[20] = magicLinkEmail;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Label htmlFor="login-email">Email</Label>;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== onMagicLinkEmailChange) {
    t14 = e_0 => onMagicLinkEmailChange(e_0.target.value);
    $[23] = onMagicLinkEmailChange;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== emailLoading || $[26] !== magicLinkEmail || $[27] !== t14) {
    t15 = <div className="space-y-1">{t13}<Input id="login-email" type="email" placeholder="you@example.com" value={magicLinkEmail} onChange={t14} disabled={emailLoading} /></div>;
    $[25] = emailLoading;
    $[26] = magicLinkEmail;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== onTurnstileExpire || $[30] !== onTurnstileSuccess || $[31] !== turnstileRef || $[32] !== turnstileSiteKey || $[33] !== turnstileTheme) {
    t16 = turnstileSiteKey && <div className="flex justify-center"><Turnstile ref={turnstileRef} siteKey={turnstileSiteKey} onSuccess={onTurnstileSuccess} onExpire={onTurnstileExpire} onError={onTurnstileExpire} options={{
        theme: turnstileTheme
      }} /></div>;
    $[29] = onTurnstileExpire;
    $[30] = onTurnstileSuccess;
    $[31] = turnstileRef;
    $[32] = turnstileSiteKey;
    $[33] = turnstileTheme;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  const t17 = emailLoading || !magicLinkEmail || !!turnstileSiteKey && !turnstileToken;
  let t18;
  if ($[35] !== emailLoading) {
    t18 = emailLoading ? <>Sending link <LoadingThreeDots variant="outline" /></> : <><Mail className="h-5 w-5" />Sign in with email</>;
    $[35] = emailLoading;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t17 || $[38] !== t18) {
    t19 = <Button type="submit" disabled={t17} className="w-full justify-center gap-2">{t18}</Button>;
    $[37] = t17;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t12 || $[41] !== t15 || $[42] !== t16 || $[43] !== t19) {
    t20 = <form onSubmit={t12} className="space-y-3">{t15}{t16}{t19}</form>;
    $[40] = t12;
    $[41] = t15;
    $[42] = t16;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t20 || $[46] !== t9) {
    t21 = <div className="space-y-3">{t9}{t11}{t20}</div>;
    $[45] = t20;
    $[46] = t9;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <p className="text-center text-muted-foreground">{"If you're having trouble logging in, please "}<Link href={LINK_SUPPORT_DOCUMENTATION_SUPPORT}>contact support</Link>.</p>;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t21 || $[50] !== t3 || $[51] !== t4) {
    t23 = <div className="flex h-screen w-full items-center justify-center bg-background"><div className="mx-4 w-full max-w-md space-y-6">{t1}{t2}{t3}{t4}{t21}{t22}</div></div>;
    $[49] = t21;
    $[50] = t3;
    $[51] = t4;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  return t23;
}
function GoogleIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="h-5 w-5" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" /><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" /><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" /><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function GitHubIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}